import React,{useState,useEffect} from "react";
import styles from "./ProductsDashboard.module.sass";
import TooltipGlodal from "../../components/TooltipGlodal";
import Overview from "./Overview";

import ProductViews from "./ProductViews";
import Products from "./Products";
import RoundGraph from "./RoundGraph";
import { getIsoDateStr } from "../../utils/analyticsUtils";

import {GET_LEADERBOARD,GET_OVERVIEW,GET_ASSIGNMENTS} from "../../API/Analytics";

const INTERVALS = ["day", "week", "month"];

const ProductsDashboard = () => {
  const [dateFilter, setDateFilter] = useState({
    currStart: getIsoDateStr(new Date()),
    currEnd: getIsoDateStr(new Date()),
    filterValue: 1,
    prevStart: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 1))),
    prevEnd: getIsoDateStr(new Date(new Date().setDate(new Date().getDate() - 1))),
  });
  const [isOverviewLoading, setIsOverviewLoading] = useState(true);
  const [isLeaderboardLoading, setIsLeaderboardLoading] = useState(true);

  const [overview, setOverview] = useState(null);
  const [leaderboard, setLeaderboard] = useState(null);

  const [asssignments, setAssignments] = useState(null);
  const [isAssignmentsLoading, setIsAssignmentsLoading] = useState(true);

  const fetchOverview = async () => {
    setIsOverviewLoading(true);
    try {
      const data = await GET_OVERVIEW(dateFilter.currStart,dateFilter.currEnd,dateFilter.prevStart,dateFilter.prevEnd);
      setOverview(data.data);
    } catch (error) {
      console.error("Failed to fetch overview:", error);
    } finally {
      setIsOverviewLoading(false);
    }
  };

  const fetchLeaderboard = async () => {
    setIsLeaderboardLoading(true);
    try {
      const data = await GET_LEADERBOARD(dateFilter.currStart,dateFilter.currEnd,dateFilter.prevStart,dateFilter.prevEnd);
      setLeaderboard(data.data);
    } catch (error) {
      console.error("Failed to fetch leaderboard:", error);
    } finally {
      setIsLeaderboardLoading(false);
    }
  }

const fetchAssignments = async () => {
    setIsAssignmentsLoading(true);
    try {
      const data = await GET_ASSIGNMENTS(dateFilter.currStart,dateFilter.currEnd);
      setAssignments(data.data);
    } catch (error) {
      console.error("Failed to fetch assignments:", error);
    } finally {
      setIsAssignmentsLoading(false);
    }
  }

  useEffect(() => {
    fetchOverview();
    fetchLeaderboard();
    fetchAssignments();
  }, [dateFilter]);

  return (
    <>
      <div className={styles.section}>
        <Overview className={styles.card} dateFilter={dateFilter} setDateFilter={setDateFilter} overviewData={overview} isLoading={isOverviewLoading} />
        <div className={styles.row}>
          <div className={styles.col}>
            <Products isLoading={isLeaderboardLoading} leaderboardData={leaderboard}/>
          </div>
          <div className={styles.col}>
            <ProductViews assignmentData={asssignments} isAssignmentsLoading={isAssignmentsLoading}/>
            <div className={styles.container}>
              {" "}
              <RoundGraph />
            </div>
          </div>
        </div>
      </div>
      <TooltipGlodal />
    </>
  );
};

export default ProductsDashboard;
